import { type RouteLocationPathRaw } from 'vue-router'
type LoginQuery = {
  redirect?: string,
  redirectQuery?: string,
}

export const loginRouteFor = (toRoute: RouteLocationPathRaw) => {
  // リダイレクト先にセットする
  const loginQuery: LoginQuery = { redirect: toRoute.path }
  
  // queryの指定がある場合
  if(toRoute.query && 0 < Object.keys(toRoute.query).length){
    loginQuery.redirectQuery = encodeURIComponent(JSON.stringify(toRoute.query))
  }

  // ログイン画面
  return { name: 'Login', query: loginQuery };
}

export const redirectRouteFor = (loginQuery: LoginQuery) => {
  const redirectUrl = loginQuery.redirect ? loginQuery.redirect : "/";
  const toRoute: RouteLocationPathRaw = { path: redirectUrl };
  // queryの指定があり場合
  if(loginQuery.redirectQuery){
    toRoute.query = JSON.parse(decodeURIComponent(loginQuery.redirectQuery))
  }
  return toRoute
}
